import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import allReducers from './reducers';
import ErrorBoundary from "./components/ErrorBoundary";

//axios.defaults.baseURL = 'http://localhost:8080';
axios.defaults.baseURL = 'https://lion.sallysg.com';
//axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');


const store = createStore(  
  allReducers,
  {},  //NOTE: Dont we need define empty state ~ {} after allReducers?  
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
